import { Pipe, PipeTransform } from "@angular/core";
import * as padStart from "core-js/fn/string/pad-start";

@Pipe({name: "runtime", pure: true})
export class RuntimePipe implements PipeTransform {
    public transform(value: string): string {
        const digits = value.replace(/:/g, "");

        if (/[^0-9]/.test(digits) || digits === "") {
            return value;
        }

        const integer = parseInt(digits, 10);

        const minutes = Math.floor(integer / 100);
        const seconds = integer % 100;

        if (seconds === 0 && minutes === 0) {
            return "";
        }

        const formattedSeconds = padStart(seconds.toString(), 2, "0");

        return `${minutes}:${formattedSeconds}`
    }
}
